// extracted by mini-css-extract-plugin
export var closeButton = "_4a-3";
export var header = "_4a-0";
export var link = "_4a-1";
export var retryButton = "_4a-2";